module.exports = __webpack_public_path__ + "static/media/tg.6ae42837.svg";